/* global attachEvent */

// **************************************************
// 1.0 - Gallery
// **************************************************

const galleryModalElements = document.querySelectorAll('[data-slider="gallery-popup-slider"]');
const gallerySections = document.querySelectorAll('.sc-gallery');
const galleryModals = [];
const getGalleryIndex = (galleryToFind) => {
  return Array.from(gallerySections).findIndex((el) => el === galleryToFind);
}

const galleryModalOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.arrow-left',
    prevEl: '.arrow-right',
  },
};

galleryModalElements.forEach((el) => {
  const galleryPopup = el.closest('.gallery-popup');
  const arrowRight = galleryPopup.querySelector('.arrow-right');
  const arrowLeft = galleryPopup.querySelector('.arrow-left');

  galleryModalOptions.navigation.nextEl = arrowRight;
  galleryModalOptions.navigation.prevEl = arrowLeft;
  galleryModals.push(new Swiper(el, galleryModalOptions));

  const index = getGalleryIndex(el.closest('.sc-gallery'));
  const galleryClose = document.querySelectorAll('.gallery-popup__close')[index];
  galleryClose?.addEventListener('click', () => {
    galleryPopup.classList.remove('is-open');
  });
});

window.addEventListener('DOMContentLoaded', (() => {
  document.addEventListener('click', (event) => {
    const galleryImg = event.target.closest('.gallery__img');
    if (galleryImg) {
      const index = getGalleryIndex(event.target.closest('.sc-gallery'));
      const galleryPopup = document.querySelectorAll('.gallery-popup')[index];
      const targetSlide = galleryImg.getAttribute('data-modalslide');
      galleryModals[index].slideTo(targetSlide - 1, 0);

      galleryPopup.classList.add('is-open');
    }
  })
}));

if (document.querySelector('.gallery .container')) {
  const buttons = document.querySelectorAll('.load-more-button .btn');
  buttons.forEach((button) => {
    button.addEventListener('click', (ev) => {
      ev.preventDefault();
      const container = ev.target.closest('.sc-gallery');
      const index = getGalleryIndex(container);
      const sendAjax = (p) => {
        const request = new XMLHttpRequest();
        const grid = container.querySelector('.gallery .container .row-grid');
        const gallery = container.querySelector('.gallery');
        const galleryPopUp = container.querySelector('.gallery-popup__inner .gallery-popup-slider .swiper-wrapper');
        request.open('POST', localData.siteURL, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        request.send(`action=getGalleryLoadMore&id=${gallery.dataset.id}&k=${gallery.dataset.k}&page-number=${gallery.dataset.page_number}`);
        request.onreadystatechange = function () {
          if (this.readyState === 4 && this.status === 200) {
            const response = JSON.parse(this.responseText);
            if (response.data.status === 200) {
              if (!response.data.next) {
                container.querySelector('.load-more-button').style.visibility = 'hidden';
                ;
              }
              let galleryHtml = '';
              let galleryPopUpHtml = '';
              let imageIndex = +gallery.dataset.page_number * 20;
              response.data.images.forEach((event) => {
                galleryHtml += `<div class="col-md-3 : col-xs-6">
                          <div class="gallery__img" style="background-image: url('${event.img_src}');" data-modalslide="${imageIndex + 1}"></div>
                        </div>`;
                galleryPopUpHtml += `<div class="swiper-slide" role="group" aria-label="${imageIndex} / ${+gallery.dataset.page_number * 20 + 20}" style="width: 1400px; opacity: 0;transform: translate3d(${-(imageIndex++ * 1400)}, 0px, 0px); transition-duration: 0ms;">
                            <div class="gallery-popup__slide : d-flex-cc">
                              <div class="gallery-popup__image">
                                <img src="${event.img_src}" alt="${event.img_alt}">
                              </div>
                            </div>
                          </div>`;
              });
              grid.innerHTML += galleryHtml;
              galleryPopUp.innerHTML += galleryPopUpHtml;
              gallery.dataset.page_number = +gallery.dataset.page_number + 1;
              galleryModals[index].update();
              galleryModals[index].pagination.update();
            }
          }
        };
      };
      sendAjax();
    });
  })
}
